import { ICalendarType } from '../Calendar';
import { ICalendarPosition } from '../View/CalendarView';
export const getAriaNavigationMonthBtn = ({
  calendarType,
  calendarPosition,
  navBtnType
}) => {
  const firstPart = `${navBtnType === 'prev' ? 'предшествующий' : 'следующий'} месяц`;
  const secondPart = calendarType === 'double' ? ` на ${calendarPosition === 'primary' ? 'первой' : 'второй'} вкладке` : '';
  return firstPart + secondPart;
};
export const getAriaCellDay = ({
  calendarType,
  calendarPosition,
  dayOfMonth,
  monthType
}) => {
  const firstPart = `${dayOfMonth} число`;
  const secondPart = ` ${monthType === 'current' ? 'текущего' : 'другого'} месяца`;
  const thirdPart = calendarType === 'double' ? ` на ${calendarPosition === 'primary' ? 'первой' : 'второй'} вкладке` : '';
  return firstPart + secondPart + thirdPart;
};
export const getAriaSelectYearBtn = ({
  calendarType,
  calendarPosition
}) => {
  const firstPart = 'выбрать год';
  const secondPart = calendarType === 'double' ? ` на ${calendarPosition === 'primary' ? 'первой' : 'второй'} вкладке` : '';
  return firstPart + secondPart;
};
export const getAriaOptionYearBtn = ({
  calendarType,
  calendarPosition,
  year
}) => {
  const firstPart = `выбрать ${year} год`;
  const secondPart = calendarType === 'double' ? ` на ${calendarPosition === 'primary' ? 'первой' : 'второй'} вкладке` : '';
  return firstPart + secondPart;
};
export const getAriaDayNavigationBtn = ({
  calendarType,
  calendarPosition,
  navBtnType
}) => {
  const navBtnTypeMap = {
    ['yesterday']: 'вчера',
    ['today']: 'сегодня',
    ['tomorrow']: 'завтра'
  };
  const firstPart = `кнопка дня соответствующего ${navBtnTypeMap[navBtnType]}`;
  const secondPart = calendarType === 'double' ? ` на ${calendarPosition === 'primary' ? 'первой' : 'второй'} вкладке` : '';
  return firstPart + secondPart;
};